import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { getMessages } from '../../../tppServices/translations/messages';
import { useIntl } from 'react-intl';
import { getApplyNowLink } from '../../../utils/trident';
import isEqual from 'lodash/isEqual';

const FinanceableBoatSummaryComponent = (props) => {

  const {listing, trackPreQualify} = props;

  const ctaLink = getApplyNowLink({isVariant: false, utmCampaign: 'YWBDPCTAs', utmContent: 'YWBDPCTAs', listing });

  const intl = useIntl();
  const formatMessage = intl.formatMessage;
  const messages = getMessages();
  const { variant3 } = messages.financeVariant;

  return (
    <div id="private-seller-boat-summary-V3-main-container" className="private-seller-boat-summary-V3-container">
      <div className="prequalify-container">
        <div className="prequalify-title">
        {formatMessage(variant3.prequalifyTitle)}
        </div>
        <ul className="summary-step-text">
          <li>{formatMessage(variant3.prequalifyLi1)}</li>
          <li>{formatMessage(variant3.prequalifyLi2)}</li>
          <li>{formatMessage(variant3.prequalifyLi3)}</li>
        </ul>
        <a href={ctaLink}
          className="prequalify-button"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            trackPreQualify('pre-qualify & get started', 'click');
          }}
        >{formatMessage(variant3.prequalifyButton)}</a>
      </div>
    </div>
  );
};

FinanceableBoatSummaryComponent.propTypes = {
  listing: PropTypes.object,
  trackPreQualify: PropTypes.func
};

export const FinanceableBoatSummary = memo(FinanceableBoatSummaryComponent, isEqual);
